import HttpClient from "HttpClient";
import apiRoutes from "../../Routes/Routes.json";

export const BatchControlsGetAll = async (payload: any) => {
  const response = await HttpClient().post(
    `/${apiRoutes.Oncology.OncologyBatchControls.GetControls}`,
    payload
  );
  return response;
};

export const BatchControlsSave = async (payload: any) => {
  const response = await HttpClient().post(
    `/${apiRoutes.Oncology.OncologyBatchControls.SaveControls}`,
    payload
  );
  return response;
};

export const BatchControlsToggleStatus = async (batchControlId: number) => {
  const response = await HttpClient().patch(
    `/${apiRoutes.Oncology.OncologyBatchControls.ToggleControlStatus}/${batchControlId}`,
    null
  );
  return response;
};
